module.exports = __webpack_public_path__ + "img/m-point.646480f9.png";